<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2376 2622"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(0.995286,0,0,0.997277,3.36271,7.13515)">
      <g id="tshirt_5_back">
        <g
          id="primary-colour"
          transform="matrix(19.431,0,0,19.4319,-12489.9,2875.35)"
        >
          <path
            d="M684.313,-143.458C683.98,-143.588 683.759,-143.664 683.665,-143.669C684.5,-144.802 688.443,-147.502 688.443,-147.502C698.788,-148.063 709.15,-148.164 719.536,-147.597L720.128,-147.352L723.907,-143.715C723.907,-143.715 723.844,-143.679 723.723,-143.613L724.166,-143.605C724.166,-143.605 744.479,-136.387 749.12,-134.897C753.762,-133.408 756.51,-122.843 757.097,-121.031C757.321,-119.262 759.107,-106.477 759.538,-102.917C759.969,-99.357 761.396,-86.931 761.388,-86.08C760.052,-85.134 755.781,-84.25 750.863,-83.822C745.945,-83.393 741.64,-85.402 741.105,-85.788C740.673,-86.44 740.145,-88.553 739.936,-89.262C739.67,-88.371 738.719,-82.082 738.472,-79.402C738.811,-76.472 739.634,-44.489 739.613,-42.735C739.592,-40.98 739.928,-33.351 740.138,-31.764C740.348,-30.178 740.582,-20.318 740.646,-19.473C738.7,-16.701 735.989,-16.194 725.909,-14.497C715.519,-12.749 702.614,-13.422 698.442,-13.488C694.271,-13.554 687.004,-14.61 679.51,-15.251C672.016,-15.892 667.806,-18.902 667.109,-19.698C667.348,-23.189 668.073,-45.573 668.174,-49.569C668.276,-53.566 668.841,-69.096 669.081,-72.834C669.322,-76.572 669.172,-80.948 668.715,-84.141C668.258,-87.333 667.597,-88.995 667.597,-88.995C667.597,-88.995 667.324,-86.986 667.005,-85.997C663.859,-84.791 660.839,-84.107 658.161,-84.018C655.217,-83.921 652.688,-84.494 650.896,-84.751C647.474,-85.242 647.252,-85.829 646.738,-86.589C646.738,-88.901 649.074,-105.516 649.636,-110.936C650.197,-116.355 649.61,-110.601 650.849,-119.85C652.088,-129.099 657.747,-134.193 658.222,-134.439C662.492,-136.69 678.962,-142.037 678.962,-142.037L683.842,-143.446L684.313,-143.458Z"
            :style="{
              fill: productColors.primary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g
          id="secondary-colour"
          transform="matrix(19.431,0,0,19.4319,-7914.39,-4578.95)"
        >
          <path
            d="M459.858,239.601C447.13,243.747 428.154,250.611 423.83,254.3C423.72,254.4 423.609,254.49 423.5,254.59C414.109,263.11 416.359,281.84 417.71,287.28C418.92,292.12 420.8,296.27 422.85,299.71C422.359,299.74 421.85,299.76 421.359,299.76C416.01,299.76 411.02,297.72 410.96,297.69L410.83,297.64L410.84,297.49C410.856,297.314 412.44,287.222 413.65,277.41C414.571,269.936 415.037,262.589 415.82,260.12C417.58,254.55 419.81,250.88 422.43,249.24L422.539,249.17C422.619,249.12 422.7,249.08 422.78,249.03C423.06,248.87 423.359,248.73 423.66,248.62C426.49,247.56 442.85,241.78 447.879,240.01C447.881,240.052 448.024,239.924 448.222,239.729C448.162,239.731 448.103,239.734 448.044,239.736C448.679,238.975 449.752,238.416 450.563,237.739C451.265,237.154 451.691,236.42 452.443,236.133C462.808,235.531 473.2,235.531 483.565,236.133C484.732,236.578 485.886,237.516 486.883,238.536C486.883,238.535 486.883,238.535 486.883,238.534C486.893,238.394 488.459,240.15 488.469,240.01C493.498,241.78 509.858,247.56 512.689,248.62C512.989,248.73 513.288,248.87 513.568,249.03C513.648,249.08 513.729,249.12 513.809,249.17L513.919,249.24C516.538,250.88 518.768,254.55 520.528,260.12C522.338,265.83 525.479,297.18 525.508,297.49L525.518,297.64L525.388,297.69C525.328,297.72 520.338,299.76 514.989,299.76C514.498,299.76 513.989,299.74 513.498,299.71C515.549,296.27 517.429,292.12 518.638,287.28C519.989,281.84 522.239,263.11 512.848,254.59C512.739,254.49 512.628,254.4 512.518,254.3C508.196,250.613 488.874,243.723 476.147,239.576C470.843,239.48 465.163,239.509 459.858,239.601ZM441.028,326.42C439.948,337.32 438.338,350.9 435.838,366.78C434.038,366.12 432.508,365.33 431.398,364.4L431.328,364.34L431.328,364.24C431.348,363.61 434.087,307.759 433.757,303.469C433.667,302.329 432.868,299.44 432.038,294.8C431.988,294.53 431.938,294.25 431.888,293.97C431.578,292.24 431.238,290.38 430.888,288.48C433.778,291.78 436.708,296.04 438.788,301.37C442.458,310.72 441.778,318.89 441.028,326.42ZM494.979,326.42C494.229,318.89 493.549,310.72 497.219,301.37C499.299,296.04 502.229,291.78 505.119,288.48C504.769,290.38 504.429,292.24 504.119,293.97C504.069,294.25 504.019,294.53 503.969,294.8C503.139,299.44 503.054,302.526 502.964,303.666C502.634,307.956 504.872,363.59 504.892,364.22L504.892,364.32L504.822,364.38C503.712,365.31 502.182,366.1 500.382,366.76C497.882,350.88 496.059,337.32 494.979,326.42Z"
            :style="{
              fill: productColors.primary_2.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g
          id="tertiary-colour"
          transform="matrix(19.431,0,0,19.4319,-7914.39,-4578.95)"
        >
          <path
            d="M460.739,239.669C460.739,239.669 461.208,239.525 460.228,239.851C448.838,243.637 428.082,251.074 423.93,254.72C423.87,254.77 423.82,254.82 423.76,254.87C423.71,254.92 423.65,254.97 423.6,255.02C414.64,263.38 416.66,281.47 418.08,287.19C419.18,291.59 420.91,295.76 423.27,299.67L422.97,299.7L422.43,299.73C420.14,295.85 418.44,291.72 417.349,287.37C415.89,281.5 413.849,262.85 423.26,254.32C423.31,254.27 423.36,254.23 423.419,254.18C423.52,254.09 423.63,253.99 423.75,253.89C427.918,250.417 447.028,243.495 458.522,239.636C459.007,239.473 459.286,239.68 459.286,239.68L460.739,239.669ZM475.585,239.674C475.104,239.515 475.744,239.639 476.41,239.631C476.824,239.627 477.185,239.421 477.483,239.521C488.936,243.357 508.387,250.383 512.598,253.89C512.718,253.99 512.828,254.09 512.928,254.18C512.988,254.23 513.038,254.27 513.088,254.32C522.498,262.85 520.458,281.5 518.998,287.37C517.908,291.72 516.208,295.85 513.918,299.73L513.378,299.7L513.078,299.67C515.438,295.76 517.168,291.59 518.268,287.19C519.688,281.47 521.708,263.38 512.748,255.02C512.698,254.97 512.638,254.92 512.588,254.87C512.528,254.82 512.478,254.77 512.418,254.72C508.199,251.016 486.847,243.401 475.585,239.674ZM441.533,326.47C440.223,339.7 438.473,353.26 436.323,366.94C435.993,366.83 435.673,366.71 435.363,366.59C437.503,353 439.233,339.52 440.533,326.37C441.213,319.55 442.053,311.06 438.323,301.55C436.613,297.2 434.193,293.15 431.073,289.46C430.953,288.82 430.833,288.18 430.713,287.53C434.443,291.65 437.303,296.22 439.253,301.19C443.073,310.92 442.213,319.54 441.533,326.47ZM494.474,326.47C493.794,319.54 492.934,310.92 496.754,301.19C498.704,296.22 501.564,291.65 505.294,287.53C505.174,288.18 505.054,288.82 504.934,289.46C501.814,293.15 499.394,297.2 497.684,301.55C493.954,311.06 494.794,319.55 495.474,326.37C496.774,339.52 498.504,353.083 500.644,366.673C500.334,366.793 500.014,366.913 499.684,367.023C497.534,353.343 495.784,339.7 494.474,326.47Z"
            :style="{
              fill: productColors.secondary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g id="outline" transform="matrix(19.431,0,0,19.4319,-5886.27,2830.92)">
          <path
            d="M348.314,-145.458C348.354,-145.537 348.432,-145.59 348.522,-145.596C358.878,-146.246 369.225,-146.162 379.588,-145.596C379.688,-145.59 379.823,-145.549 379.982,-145.466C380.269,-145.317 380.669,-145.021 381.112,-144.654C382.418,-143.569 384.122,-141.846 384.406,-141.557C385.516,-141.166 403.214,-134.92 408.426,-133.029C410.609,-132.237 412.236,-130.582 413.484,-128.598C415.323,-125.675 416.337,-122.036 417.134,-119.48C418.455,-115.241 421.385,-86.518 421.682,-83.665C421.694,-83.558 421.635,-83.456 421.537,-83.411C410.994,-78.626 401.009,-83.072 401.009,-83.072C400.943,-83.101 400.893,-83.157 400.872,-83.226C400.872,-83.226 400.39,-84.77 400.026,-85.814C399.729,-83.945 399.206,-79.848 398.923,-77.504C398.923,-77.502 398.923,-77.499 398.922,-77.497C398.508,-74.739 400.837,-18.364 400.976,-17.136C400.983,-17.073 400.965,-17.009 400.927,-16.958C399.842,-15.519 397.367,-14.328 393.932,-13.404C388.871,-12.042 381.708,-11.228 373.924,-10.908C360.316,-10.349 344.808,-11.299 335.333,-13.451C331.212,-14.387 328.223,-15.567 326.985,-16.928C326.941,-16.976 326.918,-17.039 326.92,-17.105C326.92,-17.105 329.028,-75.403 329.075,-77.478C329.11,-79.02 328.25,-83.279 327.814,-85.324C327.671,-84.729 327.475,-84.019 327.251,-83.497C327.225,-83.438 327.178,-83.39 327.118,-83.365C316.604,-78.944 307.394,-83.255 306.632,-83.562C306.529,-83.603 306.466,-83.708 306.477,-83.819C306.805,-87.073 309.174,-106.128 310.19,-114.789C310.803,-120.023 312.364,-124.752 314.281,-128.057C315.582,-130.298 317.053,-131.886 318.5,-132.56C318.502,-132.561 318.504,-132.562 318.506,-132.563C321.67,-133.936 341.755,-140.994 343.608,-141.481C345.167,-143.515 347.852,-145.083 348.314,-145.458ZM318.057,-131.737C316.9,-130.967 315.755,-129.6 314.714,-127.806C312.825,-124.55 311.291,-119.888 310.686,-114.731C309.689,-106.223 307.384,-87.68 306.993,-83.952C308.473,-83.322 317.068,-79.728 326.83,-83.787C327.222,-84.753 327.516,-86.279 327.562,-86.521C324.899,-101.464 321.713,-116.541 318.057,-131.737ZM328.071,-86.504C328.222,-85.821 329.619,-79.443 329.575,-77.467C329.529,-75.442 327.522,-19.92 327.424,-17.19C328.661,-15.907 331.533,-14.827 335.444,-13.939C344.886,-11.794 360.341,-10.851 373.903,-11.408C381.645,-11.726 388.769,-12.533 393.802,-13.887C397.037,-14.757 399.4,-15.839 400.47,-17.184C400.265,-20.133 398.022,-74.79 398.427,-77.566C398.775,-80.445 399.483,-85.944 399.7,-86.802C399.701,-86.809 399.704,-86.816 399.706,-86.823C402.376,-101.794 405.57,-116.898 409.236,-132.123C408.923,-132.289 408.596,-132.435 408.255,-132.559C403.048,-134.448 385.371,-140.687 384.242,-141.085C373.323,-141.592 354.891,-141.528 343.879,-141.044C343.849,-141.026 343.816,-141.015 343.78,-141.011C343.054,-140.933 321.96,-133.516 318.708,-132.106C318.641,-132.075 318.574,-132.041 318.507,-132.006C322.187,-116.723 325.391,-101.561 328.067,-86.533C328.069,-86.524 328.07,-86.514 328.071,-86.504ZM400.204,-86.767C400.483,-86.107 401.154,-83.993 401.315,-83.485C402.377,-83.044 411.511,-79.497 421.166,-83.793C420.784,-87.489 417.95,-115.18 416.657,-119.331C415.87,-121.854 414.876,-125.447 413.061,-128.332C412.164,-129.758 411.066,-131.011 409.688,-131.863C406.041,-116.707 402.862,-101.671 400.204,-86.767ZM383.646,-141.612C383.004,-142.253 381.782,-143.447 380.793,-144.269C380.439,-144.563 380.116,-144.808 379.863,-144.96C379.734,-145.037 379.634,-145.093 379.561,-145.097C369.256,-145.66 358.966,-145.745 348.669,-145.104C348.66,-145.095 348.65,-145.086 348.639,-145.078C348.233,-144.742 345.879,-143.378 344.318,-141.563C355.181,-142.021 372.804,-142.083 383.646,-141.612Z"
            style="fill: rgb(128, 128, 128)"
          />
        </g>
        <g
          id="cheeta-logo"
          v-if="cheetaLogo.position === 'back'"
          transform="matrix(2.97774,0,0,2.97774,1058.19,128.807)"
        >
          <path
            d="M11.062,7.23l0.679,-2.689l-3.915,0l-0.678,2.689l-1.072,4.252l-0.678,2.687l3.916,-0l0.677,-2.687l4.769,0l-1.113,4.413c-0.375,1.485 -1.71,2.526 -3.242,2.526l-6.555,0c-2.178,0 -3.775,-2.049 -3.242,-4.16l2.886,-11.446c0.374,-1.485 1.71,-2.525 3.241,-2.525l6.557,0c2.178,0 3.774,2.049 3.242,4.161l-0.701,2.78l-4.771,-0.001Zm16.353,-6.745l4.768,0l-2.205,8.551l-0.617,2.446l-1.749,6.94l-4.77,0l1.751,-6.94l-3.916,0l-1.75,6.941l-4.769,0l4.572,-17.938l4.769,0l-1.75,6.745l3.915,0l1.751,-6.745Zm9.614,4.056l-0.678,2.689l6.766,0l-1.072,4.252l-6.766,0l-0.679,2.687l6.766,-0l-1.072,4.253l-11.533,-0l4.571,-17.937l11.536,-0l-1.073,4.056l-6.766,-0Zm12.577,0l-0.68,2.689l6.766,0l-1.071,4.252l-6.766,0l-0.678,2.687l6.766,-0l-1.073,4.253l-11.534,-0l4.572,-17.937l11.535,-0l-1.071,4.056l-6.766,-0Zm22.235,-4.056l-1.072,4.056l-4.215,0l-3.499,13.881l-4.769,0l3.5,-13.881l-4.471,0l1.072,-4.056l13.454,0Zm0.511,2.329c0.375,-1.485 1.712,-2.525 3.243,-2.525l6.556,0c2.177,0 3.774,2.048 3.242,4.16l-3.522,13.972l-4.77,0l1.071,-4.252l0.679,-2.687l-3.916,0l-0.677,2.687l-1.071,4.252l-4.77,0l3.936,-15.607l-0.001,0Zm7.57,4.416l0.678,-2.689l-3.916,0l-0.678,2.689l3.916,0Zm-62.945,20.44l1.99,-7.811l4.646,0l-0.271,1.024l-3.313,0l-0.574,2.274l3.308,0l-0.282,1.12l-3.308,0l-0.575,2.274l3.31,0l-0.282,1.119l-4.649,0Zm-5.147,-0l1.712,-6.787l-2.178,-0l0.27,-1.024l5.586,-0l-0.271,1.024l-2.065,-0l-1.711,6.787l-1.343,-0Zm15.767,0.028l0.374,-1.482l0.482,-1.911l-2.905,-0l-0.855,3.394l-1.342,-0l1.774,-7.034c0.129,-0.514 0.59,-0.873 1.12,-0.873l3.206,-0c0.358,-0 0.69,0.162 0.911,0.445c0.22,0.283 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,-0.001Zm-1.767,-4.513l2.905,0l0.573,-2.275l-2.905,0l-0.573,2.275Zm27.998,4.491l1.99,-7.81l4.644,0l-0.27,1.024l-3.313,0l-0.573,2.274l3.308,0l-0.282,1.119l-3.308,0l-0.575,2.274l3.309,0l-0.282,1.119l-4.648,0Zm10.608,0.029l0.373,-1.483l0.483,-1.911l-2.906,0l-0.854,3.394l-1.343,0l1.775,-7.034c0.129,-0.513 0.589,-0.873 1.12,-0.873l3.205,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,0Zm-1.767,-4.513l2.904,0l0.574,-2.274l-2.905,0l-0.573,2.274Zm-18.914,4.471c-0.359,0 -0.691,-0.162 -0.912,-0.445c-0.221,-0.283 -0.296,-0.645 -0.209,-0.992l1.63,-6.36l1.34,0l-1.711,6.678l2.905,0l1.712,-6.678l1.34,0l-1.711,6.678l2.905,0l1.711,-6.678l1.343,0l-1.992,7.797l-8.351,0Zm-4.519,0l1.711,-6.677l-2.905,0l-1.712,6.677l-1.341,0l1.712,-6.677l-2.905,0l-1.711,6.677l-1.343,0l1.991,-7.797l8.353,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.63,6.36l-1.341,0Zm32.222,0.046l-0.227,-3.392l-1.654,0l-0.856,3.394l-1.342,0l1.23,-4.877l0.332,-1.314l0.433,-1.717l4.105,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-0.557,2.202c-0.116,0.462 -0.512,0.809 -0.985,0.864l-0.455,0.053l0.224,3.35l-1.369,0Zm-1.6,-4.511l2.906,-0l0.573,-2.273l-2.904,-0l-0.575,2.273Z"
            :style="{
              fill: cheetaLogo.color.value,
              transition: 'all 500ms',
              fillRule: 'nonzero',
            }"
          />
        </g>
      </g>
    </g>
    <rect
      id="logo-mask-1"
      x="716.231"
      y="589.85"
      width="946.655"
      height="1014.17"
      style="fill: none"
    />
    <use
      id="full-back-logo"
      :xlink:href="`#backFull${id}`"
      x="410"
      y="330"
      width="460px"
      height="514px"
      transform="matrix(1.71038,0,0,1.71038,503.522,577.002)"
    />
    <rect
      id="logo-mask-2"
      x="713.936"
      y="679.36"
      width="948.128"
      height="440.115"
      style="fill: none"
    />
    <use
      id="back-centre-logo"
      :xlink:href="`#backCenter${id}`"
      x="3750"
      y="3800"
      width="943px"
      height="306px"
      transform="matrix(1,0,0,1,-2558.56,-2895.51)"
    />

    <!--    <rect-->
    <!--      id="logo-mask-3"-->
    <!--      x="1074.65"-->
    <!--      y="264.884"-->
    <!--      width="236.764"-->
    <!--      height="124.687"-->
    <!--      style="fill: none"-->
    <!--    />-->
    <!--    <clipPath id="_clip3">-->
    <!--      <rect x="750" y="200" width="800" height="500" />-->
    <!--    </clipPath>-->

    <g clip-path="url(#_clip3)">
      <use
        id="under-back-logo"
        :xlink:href="`#backUpper${id}`"
        x="1550"
        y="850"
        width="300px"
        height="136px"
        transform="matrix(0.794512,0,0,0.794512,-47.2027,-287.969)"
      />
    </g>
    <g
      id="number-mask"
      transform="matrix(1.00273,0,0,1.00273,-3.2435,-7.15463)"
    >
      <path
        d="M423.117,829.801l1514.32,0.236l-84.755,495.828l36.699,1168.85c-81.026,146.564 -1119.53,169.825 -1415.06,10.812l36.056,-1178.61l-87.26,-497.116Z"
        style="fill: none"
      />
      <clipPath id="_clip1">
        <path
          d="M423.117,829.801l1514.32,0.236l-84.755,495.828l36.699,1168.85c-81.026,146.564 -1119.53,169.825 -1415.06,10.812l36.056,-1178.61l-87.26,-497.116Z"
        />
      </clipPath>
      <g clip-path="url(#_clip1)">
        <g
          v-if="activePlayer"
          id="player-number"
          serif:id="player number"
          transform="matrix(0.997277,0,0,0.997277,569.2,1454.36)"
        >
          <text
            text-anchor="middle"
            x="600"
            :y="`${activePlayer.playerNumberBackVerticalPosition * 10}px`"
            :style="{
              fontFamily: details.fontFamily,
              fontSize: `${activePlayer.playerNumberBackSize * 10}px`,
              fill: details.fontColor.value,
            }"
          >
            {{ activePlayer.number }}
          </text>
        </g>
      </g>
    </g>
    <g
      v-if="activePlayer"
      id="player-mask"
      transform="matrix(1.00273,0,0,1.00273,-3.2435,-7.15463)"
    >
      <path
        d="M2010.14,499.977L348.109,499.977L410.018,799.45L1943.88,799.45L2010.14,499.977Z"
        style="fill: none"
      />
      <clipPath id="_clip2">
        <rect x="350" y="0" width="2000" height="1100" style="fill: none" />
      </clipPath>
      <g clip-path="url(#_clip2)">
        <g
          id="player-name"
          serif:id="player name"
          transform="matrix(0.997277,0,0,0.997277,780.994,738.7)"
        >
          <text
            text-anchor="middle"
            x="400"
            :y="`${activePlayer.nameBackVerticalPosition * 7.1 - 360}`"
            :style="{
              fontFamily: details.fontFamily,
              fontSize: `${activePlayer.nameSize * 10}`,
              fill: details.fontColor.value,
            }"
          >
            {{ activePlayer.name }}
          </text>
        </g>
      </g>
    </g>
    <defs>
      <image
        v-if="backFullLogo"
        :width="`${backFullLogo.size}%`"
        :height="`${backFullLogo.size}%`"
        :id="`backFull${id}`"
        :href="backFullLogo.path"
        :style="{
          transform: `translate(-${
            backFullLogo.size / 2 - backFullLogo.offsetX
          }% , ${-backFullLogo.size / 2 + backFullLogo.offsetY}%)`,
          transformOrigin: `center center`,
        }"
      />
      <image
        v-if="backCenterLogo"
        :width="`${backCenterLogo.size}%`"
        :height="`${backCenterLogo.size}%`"
        :id="`backCenter${id}`"
        :href="backCenterLogo.path"
        :style="`transform: translate(-${backCenterLogo.size / 2}%, -${
          backCenterLogo.size / 2
        }%)`"
      />
      <image
        v-if="backUpperLogo"
        :width="`${backUpperLogo.size}%`"
        :height="`${backUpperLogo.size}%`"
        :id="`backUpper${id}`"
        :href="backUpperLogo.path"
        :style="{
          transform: `translate(-${
            backUpperLogo.size / 2 - backUpperLogo.offsetX
          }% , ${-backUpperLogo.size / 2 + backUpperLogo.offsetY}%)`,
          transformOrigin: `center center`,
        }"
      />
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
export default {
  name: "T_shirt_5_back",
  props: ["productColors", "logo", "activePlayer", "cheetaLogo", "details"],
  setup(props) {
    const id = Math.floor(Math.random() * 10000).toString();
    const fontFace = computed(() => getFontFace(props.details.fontFamily));

    const backFullLogo = computed(() => props.logo.backFull);
    const backCenterLogo = computed(() => props.logo.backCenter);
    const backUpperLogo = computed(() => props.logo.backUpper);

    return {
      id,
      fontFace,
      backFullLogo,
      backCenterLogo,
      backUpperLogo,
    };
  },
};
</script>
